import React from "react";
import { Shares } from "../../components/Shares";

class SharesScreen extends React.Component {
  render() {
    return (
      <div>
        <Shares
          apps={this.props.apps}
          token={this.props.ztoken}
          role={this.props.role}
          user_id={this.props.user_id}
        />
      </div>
    );
  }
}

export default SharesScreen;
